import { CircleHelp } from 'lucide-react';

import { Label } from '~shared/shadcn/ui/label';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~shared/shadcn/ui/tooltip';

export function FieldLabelWithTooltip({
  htmlFor,
  label,
  tip,
}: {
  htmlFor?: string;
  label: string;
  tip: string;
}) {
  return (
    <div className='flex items-center gap-1.5'>
      <Label htmlFor={htmlFor}>{label}</Label>
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type='button'
              className='inline-flex text-muted-foreground hover:text-foreground'
              aria-label={`About ${label}`}
            >
              <CircleHelp className='size-3.5' />
            </button>
          </TooltipTrigger>
          <TooltipContent className='max-w-xs text-xs'>{tip}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
